/**
 * ============================================================
 * Arabic
 * ============================================================
 *
 * Translators:
 *
 * Ren <admin@fatafeet.net>
 */



export default {
	'AdvanceHelp': 'للتقدم في القصة انقز بزر الفأره الأيسر او المس الشاشه في اي مكان او اضغط زر المسافة',
	'AllowPlayback': 'أضغط هنا لتفعيل امكانية تشغيل الصوت',
	'Audio': 'الأصوات',
	'AutoPlay': 'تلقائي',
	'AutoPlayButton': 'تفعيل التشغيل التلقائي',
	'AutoPlaySpeed': 'سرعة التشغيل التلقائي',

	'Back': 'تراجع',
	'BackButton': 'العودة',

	'Cancel': 'الغاء',
	'Close': 'اغلاق',
	'Confirm': 'هل ترغب بالخروج؟',
	'Credits': 'العاملين على المشروع',

	'Delete': 'حذف',
	'DialogLogButton': 'اظهار زر الحوار',

	'FullScreen': 'ملء الشاشة',

	'Gallery': 'معرض الصور',

	'Help': 'مساعده',
	'Hide': 'اخفاء',
	'HideButton': 'اخفاء صندوق الحوار',

	'iOSAudioWarning': 'اعدادات الصوت غير مدعومه على أنظمة iOS',

	'KeyboardShortcuts': 'إختصارات لوحة المفاتيح',

	'Language': 'اللغة',
	'Load': 'استرجاع',
	'LoadAutoSaveSlots': 'خانات الحفظ التلقائي',
	'LoadButton': 'فتح شاشة الحفظ والاسترجاع',
	'Loading': 'يتم الاسترجاع',
	'LoadingMessage': 'يرجى الانتظار ريثما يتم تحميل الملفات',
	'LoadSlots': 'خانات الحفظ',
	'LocalStorageWarning': 'الحفظ المحلي غير مدعوم على هذا المتصفح',
	'Log': 'سجل',

	'Music': 'صوت الموسيقى',

	'NewContent': 'توجد محتويات جديده يرجى تنشيط الصفحة لمشاهدتها',
	'NoSavedGames': 'لا توجد ملفات حفظ',
	'NoAutoSavedGames': 'لا توجد خانات حفظ تلقائي',
	'NoDialogsAvailable': 'لا توجد حوارات. ستظهر الحوارات هنا عندما يتم كتابتها',

	'OK': 'موافق',
	'OrientationWarning': 'الرجاء وضع الجهاز على الجانب الآخر لتستطيع اللعب',
	'Overwrite': 'الاستبدال',

	'QuickButtons': 'ازرار خانات الحفظ السريع',
	'QuickMenu': 'القائمة السريعة',
	'Quit': 'خروج',
	'QuitButton': 'انهاء اللعبه',

	'Resolution': 'عرض الشاشة',

	'Save': 'حفظ',
	'SaveButton': 'يفتح شاشة حفظ اللعبة',
	'SaveInSlot': 'حفظ في خانة',
	'Settings': 'إعدادات',
	'SettingsButton': 'يفتح صفحة الإعدادات',
	'Show': 'عرض',
	'Skip': 'تخطي',
	'SkipButton': 'بدء وضع التخطي',
	'SlotDeletion': 'هل أنت متأكد من رغبتك في حذف هذه الخانة؟',
	'SlotOverwrite': 'هل أنت متأكد من رغبتك في استبدال هذه الخانة؟',
	'Sound': 'مقدار صوت الاصوات',
	'Start': 'بدء',
	'Stop': 'توقف',

	'TextSpeed': 'سرعة النص',

	'Video': 'مقدار صوت الفيديو',
	'Voice': 'مقدار صوت الكلام المنطوق',

	'Windowed': 'نافذة'
};
